:host([light]) {
    & .peering_d,
    & .peering_e {
        fill: #fff;
    }
    & .peering_e,
    & .peering_f,
    & .peering_g,
    & .peering_h {
        fill-rule: evenodd;
    }
    & .peering_f {
        fill: url(#peering_c);
    }
    & .peering_g {
        fill: url(#peering_b);
    }
    & .peering_i {
        fill: none;
        stroke: #1a4e85;
        stroke-miterlimit: 10;
        stroke-width: 6px;
    }
    & .peering_j {
        fill: #1a4e85;
    }
    & .peering_h {
        fill: #bbdefb;
    }
}
:host([dark]) {
    & .peering_d,
    & .peering_e {
        fill: #09264a;
    }
    & .peering_e,
    & .peering_f,
    & .peering_g,
    & .peering_h {
        fill-rule: evenodd;
    }
    & .peering_f {
        fill: url(#peering_c);
    }
    & .peering_g {
        fill: url(#peering_b);
    }
    & .peering_i,
    & .peering_h {
        fill: #ced4db;
    }
    & .peering_j {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 6px;
    }
}
